import { createAsyncThunk } from '@reduxjs/toolkit';
import { getApplicationDetails } from '@/modules/candidate/api/application.api';

export const fetchApplicationDetailsThunk = createAsyncThunk(
  'applicationDetails/fetch',
  async (applicationId: string, { rejectWithValue }) => {
    try {
      const response = await getApplicationDetails(applicationId);
      return response.data.application;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch application details.'
      );
    }
  }
);